var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"sendVerifyCode",on:{"click":_vm.onSend}},[(_vm.second > 0)?_c('span',{attrs:{"clsss":"sendVerifyCode-second"}},[_vm._v(_vm._s(_vm.second)+"s")]):_c('span',{staticClass:"sendVerifyCode-title"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }